import { render, staticRenderFns } from "./OrdresG.vue?vue&type=template&id=c3843a72&"
import script from "./OrdresG.vue?vue&type=script&lang=js&"
export * from "./OrdresG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports